'use client'

import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { notificationsService } from '@/services/http/notificationsService'
import { DATA_TABLE_ITEMS_PER_PAGE } from '@/utils/constants'

import type { QueryParams } from '@/utils/queryParams'

type Params = {
  query: QueryParams
}

export const useUserNotifications = ({ query }: Params) => {
  const { limit = DATA_TABLE_ITEMS_PER_PAGE, page = 1 } = query
  const { toast } = useToast()

  const {
    data,
    isError,
    isLoading,
    refetch: refetchUserNotifications,
  } = useQuery({
    queryKey: [
      'notifications',
      {
        page,
        limit,
      },
    ],
    queryFn: () =>
      notificationsService.getUserNotifications({
        query: {
          page,
          limit,
        },
      }),
  })

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao carregar suas notificações',
        variant: 'destructive',
      })
    }
  }, [isError, toast])

  if (data) {
    const { notifications = [], pagination } = data
    return {
      notifications,
      pagination,
      isLoading,
      refetchUserNotifications,
    }
  }

  return {
    notifications: [],
    pagination: {
      total: 0,
      pages: 0,
      limit,
      page,
    },
    isLoading,
    refetchUserNotifications,
  }
}
